import {Component, OnInit, ViewChild} from '@angular/core';
import {BeeztelCodesService} from '../../services/beeztel-codes.service';
import {AuthService} from '../../../../../core/service/auth.service';
import {PaginationComponent} from '../../../../../shared/components/pagination/pagination.component';

import Swal from 'sweetalert2';
import {MessagingService} from '../../../../../core/service/messaging.service';
import {VnaPortalSelected} from '../../../../../core/data/messaging/VnaPortalSelected';
import {ModalService} from 'ngx-dynamic-modal';
import {CodeMappingChangeEditComponent} from '../../modals/code-mapping-change-edit/code-mapping-change-edit.component';

@Component({
  selector: 'app-mapping-change-list',
  templateUrl: './mapping-change-list.component.html',
  styleUrls: ['./mapping-change-list.component.scss']
})
export class MappingChangeListComponent implements OnInit {

    enabled: boolean = false;
    mappingChanges: Array<Object> = [];
    tmpMappingChanges: Array<Object> = [];

    startAt: number = 0;
    endAt: number = 0;
    perPage: number = 10;

    tableSearchText: string = '';

    @ViewChild(PaginationComponent) pagination: PaginationComponent;

    constructor(private codesHandler: BeeztelCodesService, private auth: AuthService, private messaging: MessagingService, private modalService: ModalService) {

    }

    ngOnInit() {
        this.getMappingsChanges();
        this.messaging.message.subscribe(
            (result) => {
                if(result instanceof VnaPortalSelected){
                    this.getMappingsChanges();
                }
            }
        );
    }

    modalCallback(res: any): void {
        this.getMappingsChanges();
    }

    newMappingChange(): void {
        this.modalService.addDynamicComponent(CodeMappingChangeEditComponent, {}, (res) => {
            this.modalCallback(res);
        })
    }

    editMappingChange(row: Object): void {
        this.modalService.addDynamicComponent(CodeMappingChangeEditComponent, row, (res) => {
            this.modalCallback(res);
        })
    }

    getMappingsChanges(): void {
        this.enabled = true;
        this.codesHandler.getMappingChanges(this.auth.getPortalSelected().portal).subscribe(
            (result) => {
                this.mappingChanges = result;
                this.endAt = (!this.haveToPaginate()) ? this.mappingChanges.length : this.perPage;
                this.tmpMappingChanges = [...this.mappingChanges];
                this.enabled = false;
            }
        )
    }

    removeMappingChange(obj: Object): void {
        this.enabled = true;
        this.codesHandler.deleteExistingMappingCode(obj['pk']).subscribe(
            (result) => {
                let idx = this.mappingChanges.findIndex((o) => {
                    return o['pk'] === obj['pk'];
                });
                this.mappingChanges.splice(idx, 1);
                Swal({'type' : 'success', 'title' : 'Action performed', 'text' : 'Mapping code change has been removed successfully'});
                this.enabled = false;
            }
        )
    }

    goToPage(n: number) {
        this.startAt = (this.pagination) ? this.pagination.getStart() : 0;
        this.endAt = (this.pagination) ? this.pagination.getEnd() : this.perPage;

    }

    haveToPaginate(): boolean {
        return this.perPage < this.mappingChanges.length;
    }

    updateFilter(e: any){
        this.tableSearchText = e.target.value.toLowerCase();
        const temp = this.tmpMappingChanges.filter((d) => {
            return d['code'].toLowerCase().indexOf(this.tableSearchText) !== -1
                || d['dialstatus'].toLowerCase().indexOf(this.tableSearchText) !== -1
                || d['status'].toLowerCase().indexOf(this.tableSearchText) !== -1
                || d['campaign_name'].toLowerCase().indexOf(this.tableSearchText) !== -1
                || !this.tableSearchText;
        });

        this.mappingChanges = temp;
    }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/tools/beeztel-codes/components/mapping-change-list/mapping-change-list.component.ts